import { Route, Switch } from "react-router-dom";
import Hero from "./components/Hero";
import Quiz from "./components/Quiz";
import About from "./components/About";
import Contact from "./components/Contact";
import Matrices from "./docs/Matrices";
import Determinants from "./docs/Determinants";
import MatricesQuiz from "./quizzes/MatricesQuiz";
import DeterminantsQuiz from "./quizzes/DeterminantsQuiz";
import Error from "./components/Error";

export default function App() {
  return (
    <>
      <Switch>
        <Route exact path="/" component={Hero} />
        <Route exact path="/quiz" component={Quiz} />
        <Route exact path="/about" component={About} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/matrices" component={Matrices} />
        <Route exact path="/determinants" component={Determinants} />
        <Route exact path="/quiz/matrices" component={MatricesQuiz} />
        <Route exact path="/quiz/determinants" component={DeterminantsQuiz} />
        <Route component={Error} />
      </Switch>
    </>
  );
}
